"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitRequest = void 0;
var InitRequest = /** @class */ (function () {
    function InitRequest() {
    }
    return InitRequest;
}());
exports.InitRequest = InitRequest;
;
//# sourceMappingURL=init.request.js.map